"use client";

import React, { Suspense } from "react";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import "@ant-design/v5-patch-for-react-19";

// 配置成中文
import { ConfigProvider, DatePicker } from "antd";
import zhCN from "antd/locale/zh_CN";
// for date-picker i18n
import "dayjs/locale/zh-cn";

export default function ZhCNConfig({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AntdRegistry>
      <ConfigProvider locale={zhCN}>{children}</ConfigProvider>
    </AntdRegistry>
  );
}

export function ZnCNDatePicker() {
  return (
    <ConfigProvider locale={zhCN}>
      <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
    </ConfigProvider>
  );
}
